<template>
  <div style="height: 100%;background-color: #fbfbfb">
    <div style="height: calc(100% - 20px);margin: 0 20px;padding-top: 20px">
      <el-row style="height: 100%;">
        <!--        <el-col :span="4" style="height: 100%;">-->
        <!--          <tree-organize ref="org" :treeObj="treeObj" @getOrgArr="getOrgArr"></tree-organize>-->
        <!--        </el-col>-->
        <el-col :span="24" style="height: 100%;">
          <div style="height: 100%;margin: 0 20px">
            <div style="height: calc(100% - 50px)">
              <el-table :data="tableData" border highlight-current-row ref="singleTable" height="100%">
                <el-table-column
                  type="index"
                  label="序号"
                  width="70"
                  align="center">
                </el-table-column>
                <el-table-column
                  prop="person_name"
                  label="老人姓名"
                  min-width="120"
                  align="center">
                </el-table-column>
                <el-table-column
                  label="老人性别"
                  min-width="80"
                  align="center">
                  <template slot-scope="scope">
                    <span>{{getSexDesc(scope.row.sex)}}</span>
                  </template>
                </el-table-column>
                <el-table-column
                  label="老人生日"
                  width="100"
                  align="center">
                  <template slot-scope="scope">
                    <span>{{scope.row.birthday}}</span>
                    <br>
                    <span>{{getAgeDesc(scope.row.birthday)}}</span>
                  </template>
                </el-table-column>
                <el-table-column
                  label="所在床位"
                  min-width="120"
                  align="center">
                  <template slot-scope="scope">
                    <span>{{getBedDesc(scope.row)}}</span>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="leave_esp_name"
                  label="申请人员"
                  min-width="80"
                  align="center">
                </el-table-column>
                <el-table-column
                  prop="leaveapplytime"
                  label="申请时间"
                  width="100"
                  align="center">
                </el-table-column>
                <el-table-column
                  prop="leavereason"
                  label="退住原因"
                  min-width="80"
                  align="center">
                </el-table-column>
                <el-table-column
                  prop="leaveremark"
                  label="退住备注"
                  min-width="80"
                  align="center">
                </el-table-column>
                <el-table-column
                  label="入住时间"
                  width="100"
                  align="center">
                  <template slot-scope="scope">
                    <span>{{getTimeDesc(scope.row.create_time)}}</span>
                  </template>
                </el-table-column>
                <el-table-column
                  label="退住时间"
                  width="100"
                  align="center">
                  <template slot-scope="scope">
                    <span>{{getTimeDesc(scope.row.leave_time)}}</span>
                  </template>
                </el-table-column>
                <el-table-column
                  label="状态"
                  min-width="80"
                  align="center">
                  <template slot-scope="scope">
                    <span>{{getCurentStateDesc(scope.row.curent_state)}}</span>
                  </template>
                </el-table-column>
                <el-table-column align="center" label="操作" min-width="100">
                  <template slot-scope="scope">
                    <el-button size="mini" type="primary" plain @click="approveCheckout(scope.row)">审批退住</el-button>
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <div style="margin-top: 10px;height: 40px;text-align: center">
              <el-pagination v-fixZoom @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage"
                             :page-sizes="[10, 20, 50, 100]" :page-size="pageSize" :total="totalCells"
                             layout="total, sizes, prev, pager, next, jumper">
              </el-pagination>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
    <el-dialog :visible.sync="checkOutShow" v-if="checkOutShow" width="800px"
               :show-close="true" :close-on-click-modal="false" center class="all-open">
      <div class="title-top-alarm">
        <span>审批退住</span>
        <div class="line-title"></div>
      </div>
      <check-out :home-bed-person-obj="listObj" v-model="checkOutShow" @updateTable="updateTable"></check-out>
    </el-dialog>
  </div>
</template>

<script>
import {queryhomebedelderly} from '../../api/yanglaoyuan/homebed'
import checkOut from './components/checkOut'

export default {
  name: 'checkOutApprove',
  components: {checkOut},
  data () {
    return {
      pageSize: 10,
      currentPage: 1,
      totalCells: 0,
      stateTypeArr: [{id: 0, name: '正常'}, {id: 1, name: '请假'}, {id: 2, name: '申请退住'}],

      tableData: [],
      listObj: {
        openType: 0,
        row: ''
      },
      checkOutShow: false
    }
  },
  created () {
    this.entityId = this.$store.state.user.LoginResp.entity_id
    this.careLevelArr = this.commonType.getCareLevelArr()
    this.getHomebedElderlyData()
  },
  methods: {
    updateTable () {
      this.getHomebedElderlyData()
    },
    handleSizeChange (val) {
      this.pageSize = val
      this.getSearchData()
    },
    handleCurrentChange (val) {
      this.currentPage = val
      this.getSearchData()
    },
    approveCheckout (row) {
      this.listObj.openType = 3
      this.listObj.row = row
      this.checkOutShow = true
    },

    // table显示
    // 获取性别描述
    getSexDesc (sex) {
      return this.util.getSex(sex)
    },
    // 获取年龄描述 ****-**-**/age
    getAgeDesc (birthDate) {
      let result = ''
      let age = this.util.getAgeByBirth(birthDate)
      if (age === '') {
        result = '--'
      } else {
        result = age + '岁'
      }
      return result
    },
    // 获取所在床位
    getBedDesc (row) {
      let result = ''
      result = row.build_name + '/' + row.floor_name + '/' + row.room_name + '/' + row.bed_name
      return result
    },
    // 获取居住状态描述
    getCurentStateDesc (curentState) {
      let result = ''
      let stateType = this.stateTypeArr.find(r => r.id === parseInt(curentState))
      if (stateType) {
        result = stateType.name
      }
      return result
    },
    getTimeDesc (time) {
      let dateTime = new Date(time)
      return dateTime.format('yyyy-MM-dd')
    },

    // 访问接口
    // 查询入住列表（仅curent_state = 2）
    getHomebedElderlyData () {
      this.tableData = []
      let params = {
        page: this.currentPage,
        size: this.pageSize
      }
      let data = {
        eid: this.entityId === 0 ? -1 : this.entityId,
        curent_state: [2],
        elderly_name: '',
        room_name: '',
        bed_name: ''
      }
      queryhomebedelderly(params, data).then(res => {
        this.totalCells = res.data.cnt
        this.tableData = res.data.homebedperson
      })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/oldPersonHome/checkOutApprove.vue